(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["buy-it-now"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('buy-it-now-button')) {
    class BuyItNowButton extends HTMLElement {
      connectedCallback() {
        this.button = this.querySelector('button');
        this.onClick = this.handleClick.bind(this);
        this.onCartUpdate = this.handleCartUpdate.bind(this);
        this.onCartError = this.handleCartError.bind(this);
        this.button.addEventListener('click', this.onClick);
      }

      disconnectedCallback() {
        this.button.removeEventListener('click', this.onClick);
        document.removeEventListener('cart:update', this.onCartUpdate);
        document.removeEventListener('cart:error', this.onCartError);
      }

      handleClick() {
        const form = this.closest('form');
        const addToCartButton = form ? form.querySelector('[name="add"]') : null;
        if (!form || !addToCartButton || this.button.disabled) return;

        this.pending = true;
        this.button.disabled = true;

        document.addEventListener('cart:update', this.onCartUpdate, { once: true });
        document.addEventListener('cart:error', this.onCartError, { once: true });

        addToCartButton.click();
      }

      handleCartUpdate() {
        if (!this.pending) return;
        window.location.href = '/cart'; // cart page hosts the Kite pickup/delivery date picker (required before checkout)
      }

      handleCartError() {
        this.pending = false;
        this.button.disabled = false;
        document.removeEventListener('cart:update', this.onCartUpdate);
      }
    }

    customElements.define('buy-it-now-button', BuyItNowButton);
  }
  } catch(e) { console.error(e); }
})();

})();
